import React from "react";

import { Stack } from "@mui/system";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import Modal from "@src/sharedComponents/Modal/Modal";
import Text from "@src/sharedComponents/Typography/Text";

import style from "./MaintenanceModal.module.css";

const texts = {
  modalTitle: "Hypothetical scenarios is temporarily unavailable",
  modalBody:
    "We’re upgrading our systems to enhance your experience. Thank you for your patience during this process.",
};

const ModalMaintenance = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={() => {}}
      modalStyle={{ width: "472px", padding: 0 }}
      className={style.container}
    >
      <Stack sx={{ gap: "8px" }}>
        <Text variant="title2">{texts.modalTitle}</Text>
        <Text variant="body" color="textSubtle">
          {texts.modalBody}
        </Text>
      </Stack>
      <Button
        sx={{ width: "100%", marginTop: "32px" }}
        onClick={onClose}
        variant="outlined"
        buttonType="primary"
        text="Close"
      />
    </Modal>
  );
};

export default ModalMaintenance;
